import { jsx as t, jsxs as C, Fragment as P } from "react/jsx-runtime";
import R, { useState as j, useRef as z, useMemo as w, useCallback as a } from "react";
import E from "classnames";
import { useIsTextOverflowing as O, useResizeObserver as U } from "@placer-ui/hooks";
import o from "./index.es685.js";
import { onKeyDownTab as V } from "./index.es503.js";
import { useScreenZoom as W } from "./index.es530.js";
import { SimpleTooltip as y } from "./index.es120.js";
import { BodyText as N } from "./index.es487.js";
import { UtilityInfoIcon as Z } from "./index.es436.js";
const q = "compact-card-component", ne = ({
  title: p,
  description: l,
  disabled: e,
  heroBanner: d,
  showInfoIcon: T,
  infoIconTooltip: m,
  tooltip: h,
  layout: f = "vertical",
  testId: s = q,
  onClick: i
}) => {
  const [$, c] = j(!1), { textElmRef: D, isOverflowing: I } = O(), { textElmRef: M, isOverflowing: H } = O(), { zoomPercentage: u } = W(), v = z(null), { containerRef: _, contentRect: g } = U(), n = w(() => u >= 200, [u]), b = E(o[`root-${f}`], o["root-base"], {
    [o.disabled]: e,
    [o.wrapping]: n
  }), A = E(o.textContainer, {
    [o.notWrapping]: !n
  }), x = a(() => {
    e || c(!0);
  }, [e]), S = a(() => {
    e || c(!1);
  }, [e]), B = a(() => {
    e || i == null || i();
  }, [e, i]), F = a(() => {
    var r;
    m ? (r = v.current) == null || r.focus() : c(!1);
  }, [m]), K = a(
    (r) => V(r, () => {
      c(!1);
    }),
    []
  ), L = w(() => {
    const r = f === "vertical";
    return n && !r ? `${g.height}px` : r ? "84px" : "78px";
  }, [g.height, n, f]);
  return /* @__PURE__ */ t(
    y,
    {
      appendToParent: !0,
      title: h || `${p}. 
${l || ""}`,
      isActive: (I || H || !!h) && !n,
      children: /* @__PURE__ */ C(
        "div",
        {
          className: b,
          onMouseEnter: x,
          onMouseLeave: S,
          onFocus: x,
          onBlur: F,
          onClick: B,
          "data-testid": s,
          role: "button",
          tabIndex: 0,
          ref: _,
          children: [
            /* @__PURE__ */ t(
              "div",
              {
                className: o.heroContainer,
                "data-testid": `${s}-hero-banner`,
                style: { height: L },
                children: R.isValidElement(d) ? R.cloneElement(d, {
                  alt: "Compact card Hero Banner"
                }) : /* @__PURE__ */ t(P, {})
              }
            ),
            /* @__PURE__ */ C("div", { className: A, children: [
              /* @__PURE__ */ t(
                N,
                {
                  variant: "semi-bold",
                  color: e ? "disabled" : "primary",
                  ref: D,
                  element: "p",
                  children: p
                }
              ),
              l && /* @__PURE__ */ t(
                N,
                {
                  variant: "regular",
                  color: e ? "disabled" : "gray",
                  ref: M,
                  element: "p",
                  children: l
                }
              )
            ] }),
            T && $ && /* @__PURE__ */ t(y, { title: m, "data-testid": `${s}-simple-tooltip`, children: /* @__PURE__ */ t(
              "span",
              {
                className: o.infoIcon,
                "data-testid": `${s}-info-icon`,
                tabIndex: 0,
                ref: v,
                onKeyDown: K,
                children: /* @__PURE__ */ t(Z, { variant: "light" })
              }
            ) })
          ]
        }
      )
    }
  );
};
export {
  q as COMPACT_CARD_DEFAULT_TESTID,
  ne as CompactCard
};
//# sourceMappingURL=index.es21.js.map
